// extracted by mini-css-extract-plugin
module.exports = {"burger":"burger-icon-module--burger--24B2m","active":"burger-icon-module--active--tPrfg"};